import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyProgressBarModule as MatProgressBarModule } from '@angular/material/legacy-progress-bar';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
import { NativeDateModule } from '@angular/material/core';
// import { DatepickerModule } from 'angular2-material-datepicker';

import 'hammerjs';

import { environment as ENV } from '../../environments/environment';

import { AutocompleteComponent } from './autocomplete/autocomplete.component';
import { ButtonComponent } from './button/button.component';
import { CardComponent } from './card/card.component';
import { DatepickerComponent } from './datepicker/datepicker.component';
// import { DigilockerComponent } from './digilocker/digilocker.component';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { InputComponent } from './input/input.component';
import { LabelComponent } from './label/label.component';
import { ListComponent } from './list/list.component';
// import { OcrUploadComponent } from './ocr-upload/ocr-upload.component';
import { ProgressComponent } from './progress/progress.component';
// import { SliderComponent } from './slider/slider.component';
import { TabComponent } from './tab/tab.component';
import { TabGroupComponent } from './tab/tab-group.component';
import { UserHistoryComponent } from './user-history/user-history.component';
import { UserStatusComponent } from './user-status/user-status.component';

// import { DigilockerService } from './digilocker/digilocker.service';
import { FileUploadService } from './file-upload/file-upload.service';
import { TitleCasePipe } from './title-case.pipe';
import { ApplicantService } from 'app/laas/applicant.service';

import { ButtonNoLabelComponent } from './button-no-label/button-nolabel.component';

import { InputNoLabelComponent } from './input-nolabel/input-nolabel.component';
import { InputNoLabelwmComponent } from './input-nolabelwm/input-nolabelwm.component';
import { AutocompleteNoLabelComponent } from './autocomplete-NoLabel/autocomplete-nolabel.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { SpinnerOverlayComponent } from './spinner-wrapper/spinner-overlay-wrapper.component';
import { AutocompleteBiComponent } from './autocomplete-bilingual/autocomplete.component';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyCard as MatCard, MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatLegacyCardContent as MatCardContent } from '@angular/material/legacy-card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';



@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    MatDialogModule,
    NativeDateModule,
    MatAutocompleteModule,
    MatInputModule,
    MatButtonModule,
    MatCardModule,
    MatDatepickerModule,
    MatIconModule,
    MatSelectModule,
    MatProgressBarModule,
    MatTabsModule,
    MatIconModule,
    MatCardModule,
    MatRadioModule,
    MatProgressSpinnerModule

  ],
  declarations: [
    AutocompleteComponent,
    ButtonComponent,
    CardComponent,
    DatepickerComponent,
    // DigilockerComponent,
    FileUploadComponent,
    InputComponent,
    InputNoLabelComponent,
    InputNoLabelwmComponent,
    LabelComponent,
    ListComponent,
    // OcrUploadComponent,
    ProgressComponent,
    // SliderComponent,
    TabComponent,
    TabGroupComponent,
    UserHistoryComponent,
    UserStatusComponent,
    TitleCasePipe,
    ButtonNoLabelComponent,
    AutocompleteNoLabelComponent,
    SpinnerComponent,
    SpinnerOverlayComponent,
    AutocompleteBiComponent
  ],
  exports: [
    AutocompleteComponent,
    ButtonComponent,
    CardComponent,
    DatepickerComponent,
    // DigilockerComponent,
    FileUploadComponent,
    InputComponent,
    InputNoLabelComponent,
    InputNoLabelwmComponent,
    LabelComponent,
    ListComponent,
    // OcrUploadComponent,
    ProgressComponent,
    // SliderComponent,
    TabComponent,
    TabGroupComponent,
    UserHistoryComponent,
    UserStatusComponent,
    TitleCasePipe,
    ButtonNoLabelComponent,
    AutocompleteNoLabelComponent,
    SpinnerComponent,
    SpinnerOverlayComponent,
    AutocompleteBiComponent
  ],
  providers: [
    // DigilockerService,
    FileUploadService,

  ],
})
export class CoreModule { }
